/**
 * @file: getSiteInspectionDefectiveLevelPatched.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { getDefectiveLevel } from '@euler/functions/getDefectiveLevel';
import { DefectiveLevel } from '@euler/model';
import { SiteInspection } from '@euler/model/task-detail';
import { comparerDesc } from '@euler/utils';
import { uniq } from 'ramda';

export const getSiteInspectionDefectiveLevelPatched = (
  inspectedSite: SiteInspection,
): DefectiveLevel => {
  if (inspectedSite.customIssues.length > 0) {
    const defectiveLevel =
      uniq([
        ...inspectedSite.items.map(p =>
          getDefectiveLevel(p.abnormalLevel, p.severityLevel),
        ),
        ...inspectedSite.customIssues.map(p =>
          getDefectiveLevel(p.abnormalLevel, p.severityLevel),
        ),
      ]).sort(comparerDesc)[0] ?? DefectiveLevel.Fine;
    return defectiveLevel;
  }
  return getDefectiveLevel(
    inspectedSite.abnormalLevel,
    inspectedSite.severityLevel,
  );
};
